import React from 'react'
import {defineMessages, useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {showNearestResults} from 'events/map'
import {getIsFiltersApplied} from 'modules/sapiSearch/selectors'
import {getLayout} from 'modules/search/selectors'
import {LayoutType} from 'modules/search/types'

import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

const ButtonWrapper = styled('div')`
  margin-top: ${cssTheme.layout.spacing.s500};
`
const mapNoResults = defineMessages({
  noResultsInThisArea: {
    id: 'mapNoResults.noResultsInThisArea',
    defaultMessage: 'No results in this area'
  },
  noMoreResultsInThisArea: {
    id: 'mapNoResults.noMoreResultsInThisArea',
    defaultMessage: 'No more results in this area'
  }
})

const BodyMessage = ({isFiltersApplied}: {isFiltersApplied: boolean}) => {
  if (isFiltersApplied) {
    return (
      <FormattedMessageWrapper
        id="mapNoResults.tryRemoveFilters"
        defaultMessage="Try adjusting your search criteria or removing some filters."
      />
    )
  }

  return (
    <FormattedMessageWrapper
      id="mapNoResults.tryChangeArea"
      defaultMessage="Try changing your search area."
      values={{br: () => ''}}
    />
  )
}

interface Props {
  noMoreResults?: boolean
}

export const NoResults = ({noMoreResults}: Props) => {
  const {formatMessage} = useIntl()
  const isFiltersApplied = useSelector(getIsFiltersApplied)
  const layout = useSelector(getLayout)

  const title = formatMessage(
    noMoreResults
      ? mapNoResults.noMoreResultsInThisArea
      : mapNoResults.noResultsInThisArea
  )

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap="s500">
      <Text variant="titleL">{title}</Text>
      <Text variant="bodyM">
        {<BodyMessage isFiltersApplied={isFiltersApplied} />}
      </Text>
      {layout !== LayoutType.LIST && (
        <ButtonWrapper>
          <Button variant="tertiary" size="xl" onClick={showNearestResults}>
            <FormattedMessageWrapper
              id="mapNoResults.showNearestResults"
              defaultMessage="Show nearest results"
            />
          </Button>
        </ButtonWrapper>
      )}
    </Box>
  )
}
